import * as React from "react";
import Modal from "@mui/material/Modal";
import ContractSettings from "./ContractSettings";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function ContractModal(props) {
  const [contract, setContract] = React.useState(props.contract || null);
  const [open, setOpen] = React.useState(props.open);

  const handleClose = () => {
    console.log(contract);
    setContract({ name: "" });
    props.setOpen(false);
  };

  return (
    <div
    // style={{
    //   display: "flex",
    //   justifyContent: "space-between",
    //   alignItems: "center",
    // }}
    >
      {contract !== null ? (
        <Modal
          style={{
            overflow: "auto",
            // maxHeight: "600px",
          }}
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <ContractSettings contract={contract} onClose={handleClose} />
        </Modal>
      ) : (
        <Modal
          style={{
            overflow: "auto",
            // maxHeight: "600px",
          }}
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <ContractSettings onClose={handleClose} />
        </Modal>
      )}
    </div>
  );
}
